import { EventType } from "../enums/enum";

export const MAIN_EVENT_NAMES: Partial<Record<EventType, string>> = {
  KateAngaokBimong: "Katé",
  VietnameseLunarNewYear: "Tết Nguyên Đán",
  AwalNewYear: "Năm mới Awal",
  TamaRicaowRamawan: "Ramâwan",
  AkaokThun: "Năm mới Chăm lịch",
  RijaNagar: "Rija Nagar"
};
